module.exports = __webpack_public_path__ + "img/10.48141600.jpg";